import { inject, Injectable } from '@angular/core';
import { AnalysisVersionStatus } from '@api-types/enums/analysis-version-status.enum';
import { AnalysisProgressSseEventPayload } from '@api-types/sse/event-payloads/analysis-progress.sse-event-payload';
import { SseEventType } from '@api-types/sse/sse.types';
import { SseEventHandler } from '@core/sse/sse-event-handler';
import { AnalysisStateService } from './analysis-state.service';

@Injectable()
export class AnalysisProgressSseHandler implements SseEventHandler<
  typeof SseEventType.AnalysisProgress
> {
  private readonly analysisStateService = inject(AnalysisStateService);

  readonly eventType = SseEventType.AnalysisProgress;

  handle(payload: AnalysisProgressSseEventPayload): void {
    this.analysisStateService.patchVersion(payload);

    if (payload.status === AnalysisVersionStatus.FINISHED) {
      this.analysisStateService.tableVersionGroups.reload();
      this.analysisStateService.aggregatedVersionGroup.reload();
    }
  }
}
